import React from 'react';
import {
  sanitizeUnsafeHTML,
  sanitizeConfigOptions,
} from '@labxchange/util-sanitization';
import { useHistory } from 'react-router-dom';

import { ItemResponse } from 'labxchange-client';
import { detailUrlForEntity } from 'library/utils';
import { getItemTypeMeta } from 'items/models';
import { analyticsInstance, EVENT_NAMES } from 'tracking';
import { WrappedMessage, getHomeVariationExperimentValue } from 'utils';
import { ItemIcon } from 'library/components';
interface PlainAssetCardProps {
  asset: ItemResponse;
  curriculumSlug: string;
  trackingData?: Record<string, string>;
  onCardClick?: (e: React.MouseEvent) => void;
}

export const PlainAssetCard = ({
  asset,
  curriculumSlug,
  onCardClick,
  trackingData = {},
}: PlainAssetCardProps) => {
  const history = useHistory();
  const experimentVariation = getHomeVariationExperimentValue(curriculumSlug);
  const assetURL = detailUrlForEntity(asset.metadata);
  const defaultCardImage =
    getItemTypeMeta(asset.metadata.type)?.defaultCardImage ||
    '/assets/images/default-featured.png';
  const backgroundImage = `url(${asset.metadata.imageUrl || defaultCardImage})`;

  const handleCardClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onCardClick) {
      onCardClick(e);
    }
    analyticsInstance.track(
      EVENT_NAMES.NewHomePageAssetCardClicked(experimentVariation),
      {
        asset_id: asset.metadata.id,
        asset_title: asset.metadata.title,
        asset_type: asset.metadata.type,
        asset_url: assetURL,
        url: window.location.toString(),
        ...trackingData,
      }
    );
    history.push(assetURL);
  };

  const renderItemTypeInfo = () => {
    if (asset.metadata && asset.metadata.type) {
      return (
        <div className='asset-info'>
          <ItemIcon itemType={asset.metadata.type} zoom='14' />
          <span>
            <WrappedMessage
              message={getItemTypeMeta(asset.metadata.type)?.name}
              values={{ count: asset.metadata.itemCount || 0 }}
            />
          </span>
        </div>
      );
    }
    return null;
  };

  return (
    <div className='plain-asset-card' onClick={handleCardClick}>
      <div
        className='plain-asset-image'
        role='presentation'
        style={{ backgroundImage }}
      />
      <div className='plain-asset-details'>
        <div className='plain-asset-title'>
          <span className='asset-title'>{asset.metadata.title}</span>
        </div>
        <div className='plain-asset-description-wrapper'>
          <div className='asset-description'>
            <span>
              {sanitizeUnsafeHTML(
                asset.metadata.description,
                sanitizeConfigOptions.StripHTML
              )}
            </span>
          </div>
        </div>
        <div className='asset-info-wrapper'>{renderItemTypeInfo()}</div>
      </div>
    </div>
  );
};
